export enum VOUCHER_GENERATION_MODE {
  MANUAL = 'MANUEL',
  AUTO = 'AUTO',
}

export enum VOUCHER_COMPUTE_MODE {
  NUMERAL = 'NUMERAIRE',
  PERCENT = 'POURCENTAGE',
}



// WEBPACK FOOTER //
// /usr/app/src/app/core/services/vouchers/vouchers.constants.ts